import { Link } from 'react-router-dom';

export default function MarketplaceHero() {
  return (
    <section className="relative bg-gradient-to-br from-orange-50 via-white to-amber-50 pt-32 pb-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-sparkling-fill"></i>
              <span>AI-Powered Job Matching</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              AI Generates Jobs.<br />
              <span className="text-orange-600">You Claim Them.</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              The first AI-powered job marketplace for Australian tradies. Homeowners post needs, our AI creates detailed job listings with scope and budget estimates. You browse, apply, and get hired.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              <div>
                <div className="text-3xl font-bold text-orange-600">2,400+</div>
                <div className="text-sm text-gray-600">Active Jobs</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-600">$8.2M</div>
                <div className="text-sm text-gray-600">Jobs Completed</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-600">4.9★</div>
                <div className="text-sm text-gray-600">Avg Rating</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap gap-4">
              <Link
                to="/signup"
                className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <span>Find Jobs Now</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-all border-2 border-gray-200 whitespace-nowrap cursor-pointer"
              >
                <span>Post a Job</span>
                <i className="ri-add-circle-line"></i>
              </Link>
            </div>

            {/* Trust Badges */}
            <div className="flex items-center gap-6 mt-8 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-fill text-green-600 text-lg"></i>
                <span>Verified Clients</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-secure-payment-fill text-green-600 text-lg"></i>
                <span>Secure Payments</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-fill text-green-600 text-lg"></i>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/5fc59b83d8c9bfff50fb9f200691a5aa.jpg"
                alt="Tradie using job marketplace app"
                className="w-full h-full object-cover object-top"
              />
              {/* Floating Job Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white rounded-xl shadow-xl p-4 backdrop-blur-sm bg-opacity-95">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">Kitchen Renovation</div>
                    <div className="text-xs text-gray-600">Bondi, NSW</div>
                  </div>
                  <div className="bg-red-100 text-red-700 text-xs font-medium px-2 py-1 rounded whitespace-nowrap">
                    Urgent
                  </div>
                </div>
                <div className="text-lg font-bold text-orange-600 mb-2">$8,500 - $12,000</div>
                <div className="flex items-center gap-2 text-xs text-gray-600">
                  <i className="ri-time-line"></i>
                  <span>Posted 2 hours ago</span>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-orange-500 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-amber-500 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}